import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { TranslateService } from '@ngx-translate/core';

import {
  CtaButtonComponent,
  RichTextLinkComponent,
} from '@digital-platform/rs-cms/feature-ptypes';
import { IconComponent } from '@digital-platform/rs-shared/ui-brand';

@Component({
  selector: 'digital-platform-canadian-customer-modal-component',
  templateUrl: './canadian-customer-modal.component.html',
  styleUrls: ['./canadian-customer-modal.component.scss'],
  standalone: true,
  imports: [
    CtaButtonComponent,
    IconComponent,
    RichTextLinkComponent,
    CommonModule,
    TranslateModule,
  ],
})
export class CanadianCustomerModalComponent {
  activeModal = inject(NgbActiveModal);
  private translateService = inject(TranslateService);

  dismiss(): void {
    this.activeModal.dismiss();
  }

  createCMSObject = function (nameOfProperty: string, valueOfProperty: string) {
    return {
      tid: 0,
      name: '',
      [nameOfProperty]: valueOfProperty,
    };
  };

  navigateToWasteco(): void {
    this.translateService
      .get('CANADIAN_CUSTOMER_MODAL.WASTECO_URL')
      .subscribe((translatedUrl: string) => {
        window.location.href = translatedUrl;
      });
  }
}
